<template>
  <PullRefresh v-model="refreshing" @refresh="handleRefresh" :pulling-text="$t('pullRefresh.pulling')"
    :loosing-text="$t('pullRefresh.pulling')" :loading-text="$t('pullRefresh.loading')"
    :success-text="$t('pullRefresh.success')" class="list_wrap">
    <List v-model="loading" :finished="!hasMore" :finished-text="$t('noMore')" :loading-text="$t('pullRefresh.loading')"
      @load="onload" :error.sync="error" :error-text="$t(errorMsg)" :style="{ '--wrapHieght': wrapHeight }">
      <div v-for="(item, index) in list" :key="item.id" :class="{ 'flex_list': flex, [listWrapClass || '']: true }">
        <slot name="item" :item="item" :index="index">
          {{ item }}
        </slot>
      </div>
      <template #finished>
        <div v-if="!isError">
          <div class="nodata" v-if="!list.length">
            <VanImage :src="verConfig.nulltrade || nullImg" mode="aspectFit" style="height: calc(160rem / 16);" />
            {{ $t("noMore") }}
          </div>
          <div class="nomore" v-else>
            {{ $t("noMore") }}
          </div>
        </div>
      </template>
    </List>
  </PullRefresh>
</template>

<script>
import { Toast, PullRefresh, List, Image as VanImage } from 'vant';
import { GET_LIST_COM } from "@/api";
import noDataBack from "@/assets/Img/null/null1.png";

export default {
  components: {
    PullRefresh, List, VanImage
  },
  props: {
    url: String,
    initParams: Object,
    perPage: {
      type: Number,
      default: 10,
    },
    dataKey: {
      type: String,
      default: "lists",
    },
    nullImg: {
      type: String,
      default: noDataBack
    },
    cusLoad: Boolean,
    listWrapClass: String,
    flex: Boolean,
    isError: Boolean,
    wrapHeight: {
      type: String,
      default: '0px'
    }
  },
  data: () => ({
    refreshing: false,
    list: [],
    hasMore: true,
    loading: false,
    page: 0,
    params: {},
    error: false,
    errorMsg: 'listStatus.error'
  }),
  created() {
    if (!this.url) return;
    // this.getList();
  },
  methods: {
    genParams() {
      this.params.page_size = this.perPage;
      this.params.page = this.page;
      if (this.initParams) {
        this.params = { ...this.params, ...this.initParams };
      }
    },
    setLoading() {
      this.loading = true;
    },
    clearLoading() {
      this.loading = false;
      this.refreshing = false;
    },
    onload() {
      if (!this.url) return;
      if (this.cusLoad && this.page === 0) {
        this.hasMore = false;
        this.loading = false;
        return
      }
      this.getList();
    },
    async getList() {
      this.page++;
      this.genParams();
      if(!this.refreshing){
        this.setLoading();
      }else{
        this.loading = false
      }
      try {
        const r = await GET_LIST_COM(
          this.url,
          this.params
        );
        const { currentPage, hasMorePages, lists } = r;
        this.hasMore = hasMorePages;
        if (currentPage === 1) {
          this.list = lists;
        } else {
          this.list = [...this.list, ...lists];
        }
        this.clearLoading();
      } catch (error) {
        console.error("列表数据获取失败:", {
          msg: error,
          url: this.url
        })
        this.page--;
        this.clearLoading();
        this.error = true;
        this.errorMsg = error.msg;
        Toast(this.$t(error.msg))
      }
    },
    handleRefresh(params = {}) {
      this.refreshing = true;
      this.page = 0;
      this.hasMore = true;
      this.params = { ...this.params, ...params }
      this.list= []
      this.getList();
    }
  },
}
</script>

<style lang="less" scoped>
.nomore {
  line-height: 50px;
}

.list_wrap {
  min-height: 30rem;
}

.nodata {
  max-width: 750px;
  width: 100%;
  // height: calc(100vh - calc(46rem / 16) - var(--wrapHieght));
  padding: calc(32rem / 16) 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.flex_list {
  display: flex;
  flex-wrap: wrap;
}
</style>